<template>
  <component
    :is="component"
    v-if="component"/>
</template>

<script>
import { mapState } from 'vuex';
import Signup from '@/pages/Signup.vue';
import PhoneCode from '@/pages/PhoneCode.vue';
import Success from '@/pages/Success.vue';

export default {
  components: {
    Signup,
    PhoneCode,
    Success,
  },
  computed: {
    ...mapState({
      step: (state) => state.step,
    }),
    component() {
      switch (this.step) {
        case 1:
          return 'Signup';
        case 2:
          return 'PhoneCode';
        case 3:
          return 'Success';
        default:
          return null;
      }
    },
  },
  watch: {
    step: {
      handler() {
        window.scrollTo(0, 0);
      },
    },
  },
};
</script>
